import * as React from 'react';

const StarIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={12} height={11} fill="none" {...props}>
    <path
      fill="#fff"
      d="m5.718.435 1.58 3.404 3.805.416-2.827 2.52.77 3.66L5.718 8.59 2.39 10.435l.77-3.66-2.827-2.52 3.805-.416L5.718.435Z"
    />
  </svg>
);
export { StarIcon };
